import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { useCollection } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import { IluckydrawItem } from '@typings/store/luckydraw.interface';
import Slider from '@components/dataDisplay/slider/Slider';
import LuckyDrawModal from './detail/LuckyDrawModal';
import ItemMaterialSec from '@components/dataDisplay/slider/ItemMaterialSec';

const Container = styled.div`
  padding: 12px;
  width: 100%;
  height: 260px;
  object-fit: contain;
  position: relative;
  flex-shrink: 0;
`;


function LuckyDrawSlider() {
  const collectionPath = `${CollectionPath.LUCKYDRAW}`;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<IluckydrawItem | any>();
  const { data: slideList } = useCollection<IluckydrawItem>(collectionPath, {
    listen: true,
    orderBy: ['order', 'desc'],
  });

  const handleClick = useCallback((data) => {
    setSelectedData(data);
    setOpenModal(true);
  }, []);

  return (
    <>
      <Container>
        <Slider
          list={slideList || []}
          customContents={(itemData) => (
            <ItemMaterialSec
              style={{
                position: 'absolute',
                left: '50%',
                bottom: 50,
                transform: 'translateX(-50%)',
              }}
              data={itemData}
              handleClick={() => handleClick(itemData)}
            />
          )}
        />
      </Container>
      {openModal && (
        <LuckyDrawModal
          data={selectedData}
          closeModal={() => setOpenModal(false)}
        />
      )}
    </>
  );
}


export default LuckyDrawSlider;